export const EditNotification = ({
	notification,
	setAction,
	onRequestClose,
}) => {
	return <div></div>;
};
